import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-search-panel',
  templateUrl: './search-panel.component.html',
  styleUrls: ['./search-panel.component.scss']
})
export class SearchPanelComponent implements OnInit {

  constructor(
    public loadingSvc: LoadingService,
    public dataSvc: DataService
  ) { }

  ngOnInit() {
    
  }

  filterChanged() {
    clearTimeout(this.dataSvc.syncTimeout);
    clearTimeout(this.dataSvc.searchTimeout);
    
    this.loadingSvc.changeLoading("data.loadFilteredSearchData", true);
    
    this.dataSvc.syncTimeout = setTimeout(() => {
      this.dataSvc.syncFilters();
      this.dataSvc.searchTimeout = setTimeout(async () => {
        await this.dataSvc.applySearch();
        this.dataSvc.syncFilters();
        this.loadingSvc.changeLoading("data.loadFilteredSearchData.timeout", false);
      }, 300);
    }, 200);
  }
}